import { metricKeys } from '@pulse/metrics';
import isEqual from 'lodash/isEqual';
import getFilterFromRules from './filter/getFilterFromRules';

// starting from the set above, list of metrics to include or exclude
export const dataFilterMetricsList = {
  'client-side': {
    include: [metricKeys.VideoStartFailuresPercentage, metricKeys.VideoStartTime],
    exclude: [metricKeys.AdSlateDurationPct, metricKeys.AdSlatePlaysPct],
  },
  'server-side': {
    include: [metricKeys.AdSlatePlaysPct],
    exclude: [metricKeys.VideoStartFailuresPercentage, metricKeys.VideoStartTime],
  },
  vpaid: {
    include: [metricKeys.VideoStartFailuresPercentage, metricKeys.VideoStartTime],
    exclude: [
      metricKeys.RebufferingRatio,
      metricKeys.Bitrate,
      metricKeys.AdSlateDurationPct,
      metricKeys.AdSlatePlaysPct,
    ],
  },
};

// preset data source filters
export const presetFilters = {
  'client-side': {
    'Client Side': {
      field: 'TAG',
      key: 'c3.ad.technology',
      op: 'eq',
      value: 'Client Side',
      display: 'Client Side',
    },
  },
  'server-side': {
    'Server Side': {
      field: 'TAG',
      key: 'c3.ad.technology',
      op: 'eq',
      value: 'Server Side',
      display: 'Server Side',
    },
  },
  vpaid: {
    VPAID: {
      field: 'TAG',
      key: 'c3.ad.mediaFileApiFramework',
      op: 'eq',
      value: 'VPAID',
      display: 'VPAID',
    },
  },
};

const presetRulesList = [];
// build rules
Object.entries(presetFilters).forEach(([id, rules]) => {
  const filter = getFilterFromRules(rules);
  presetRulesList.push({ presetFid: id, rules: filter.rule });
});

// check if input rules matches any of the preset rules
// returns for first match, defaults to undefined
export function getPresetFid(rules) {
  const res = presetRulesList.find((preset) => isEqual(preset.rules, rules));
  return res ? res.presetFid : undefined;
}
